import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const HomeRedirectGuard: CanMatchFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (!authService.isLoggedIn) {
    return true; // accès à la landing page
  }

  const profile = authService.profile;

  switch (profile) {
    case 'SUPER_ADMIN':
      router.navigate(['/admin-global']);
      break;
    case 'ADMIN_ENTREPRISE':
      router.navigate(['/admin-entreprise']);
      break;
    default:
      router.navigate(['/salarie']);
  }

  return false;
};
